import { render, staticRenderFns } from "./wxQrcode.vue?vue&type=template&id=1fd6cc64&scoped=true&"
import script from "./wxQrcode.vue?vue&type=script&lang=js&"
export * from "./wxQrcode.vue?vue&type=script&lang=js&"
import style0 from "./wxQrcode.vue?vue&type=style&index=0&id=1fd6cc64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6cc64",
  null
  
)

export default component.exports